//Handle Code snippets throughout site
//Add appropriate class to markdown generated code elements for prism to format
$(function(){
	var CODE_FILE_CONVERSION = {
		"js": "javascript",
		"html": "markup"
	}

	//Add appropriate prism class name for syntax highlighting
	$("code[data-language]").each(function () {
		var $code = $(this);
		var sType = $code.attr("data-language");
		var sClassName = "language-" + (CODE_FILE_CONVERSION[sType] || sType);
		$code.addClass(sClassName);
	});
})